<i18n src="./../../i18n/basket_content.json"></i18n>

<template>
    <div class="container-fluid mt-subpage-section m-0 p-0">
        <div class="container-fluid m-0 p-0">
            <div class="lazy container-fluid">
                <div class="container">
                    <div class="content-container p-3 pt-5">
                        <div class="row">
                            <div class="col-lg-7">
                                <p class="mt-2" style="font-size: 40px;" v-text="$t('basket.title')" />
                                <div>
                                    <product-summary v-for="item in getCart" :key="item.id" class="container mb-3" :item="item"/>
                                    <delivery-form ref="deliveryFormComp" :delivery-form="deliveryForm"/>
                                    <checkout-form ref="checkoutFormComp" :checkout-form="checkoutForm"/>
                                    <payment-form v-if="canPay" ref="paymentFormComp" :payment-form="paymentForm"/>
                                    <consent-form ref="consentFormComp" :consent-form="consentForm"/>
                                </div>
                            </div>
                            <div class="col-lg-1"/>
                            <div class="col-lg-4 pl-3 sticky-col">
                                <p class="mt-2" style="font-size: 40px;" v-text="$t('basket.summary')" />
                                <cart-summary-form ref="cartSummaryFormComp" :delivery-form="deliveryForm"/>
                            </div>
                        </div>
                    </div>

                    <main-footer/>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import MainFooter from "@/components/commons/MainFooter";
    import {Const} from "@/main";
    import axios from "axios";
    import {mapGetters} from "vuex";
    import ProductSummary from "@/components/basket/ProductSummary";
    import CheckoutForm from "@/components/basket/CheckoutForm";
    import ConsentForm from "@/components/basket/ConsentForm";
    import LazyLoad from "vanilla-lazyload";
    import DeliveryForm from "./DeliveryForm";
    import $ from "jquery";
    import PaymentForm from "@/components/basket/PaymentForm.vue";
    import CartSummaryForm from "@/components/basket/CartSummaryForm.vue";

    var lazyLoadInstance = new LazyLoad({
        elements_selector: ".lazy"
    });

    export default {
        name: "BasketContent",
        components: {
            CartSummaryForm,
            PaymentForm,
            DeliveryForm, ConsentForm, CheckoutForm, ProductSummary, MainFooter},
        data () {
            return {
                deliveryForm: {
                    address: {
                        latitude: Const.GOOGLE_MAPS_CENTER_LATITUDE,
                        longitude: Const.GOOGLE_MAPS_CENTER_LONGITUDE,
                        name: ''
                    },
                    startDate: '',
                    endDate: '',
                    contactPhone: '',
                    deliveryInfo: ''
                },
                checkoutForm: {
                    type: '',
                    name: '',
                    surname: '',
                    phone: '',
                    email: '',
                    address: '',
                    city: '',
                    postal: '',
                    nip: '',
                    coName: '',
                },
                paymentForm: {
                    method: ''
                },
                consentForm: {
                    statConsent: false,
                    owuConsent: false,
                    adConsent: false
                },
                summaryPrice: 0,
                canPay: false,
                locale: this.$i18n.locale
            }
        },
        computed: {
            ...mapGetters(['getCart']),
            period() {
                const calcStartDate = this.parseDate(this.deliveryForm.startDate)
                const calcEndDate = this.parseDate(this.deliveryForm.endDate)
                return this.calculatePeriod(calcStartDate, calcEndDate)
            }
        },
        mounted() {
            if (this.getCart.length > 0) {
                let availableItems = 0;
                for (let position = 0; position < this.getCart.length; position++) {
                    if (this.getCart[position].canBuy) {
                        availableItems++
                    }
                }
                if (Const.ACTIVE_PAYMENT_GATEWAY !== '' && availableItems === this.getCart.length) {
                    this.canPay = true
                }
            }
            $('.mt-checkout .form-type-textfield input').keyup(function () {
                if ($(this).val() === '') {
                    $("label[for='" + $(this).attr('id') + "']").show(200);
                } else {
                    $("label[for='" + $(this).attr('id') + "']").hide();
                }
            });

            $('.mt-checkout .form-type-textfield textarea').keyup(function () {
                if ($(this).val() === '') {
                    $("label[for='" + $(this).attr('id') + "']").show(200);
                } else {
                    $("label[for='" + $(this).attr('id') + "']").hide();
                }
            });

            this.$nextTick(() => {
                lazyLoadInstance.update()
            })
        },
        methods: {
            parseDate(date) {
                var dateStr = date.toString().replace(/\D/g,'')
                return new Date(
                    Number(dateStr.substr(4, 4)),
                    Number(dateStr.substr(2, 2)) - 1,
                    Number(dateStr.substr(0, 2)),
                )
            },
            calculatePeriod(startDate, endDate) {
              return Math.round((endDate.getTime() - startDate.getTime()) / 86400000)
            },
            validateForms() {
                let deliveryFormValid = this.$refs.deliveryFormComp.validate();
                let checkoutFormValid = this.$refs.checkoutFormComp.validate();
                let paymentFormValid = this.$refs.paymentFormComp.validate();
                let consentFormValid = this.$refs.consentFormComp.validate();

                let isValid = checkoutFormValid && consentFormValid && paymentFormValid && deliveryFormValid;
                if (!isValid) {
                    var element = null
                    if (!deliveryFormValid) {
                        element = document.getElementById('form-delivery');
                    } else if (!checkoutFormValid) {
                        element = document.getElementById('form-checkout');
                    } else if (!paymentFormValid) {
                        element = document.getElementById('form-payment');
                    } else {
                        element = document.getElementById('form-consent');
                    }

                    var rect = element.getBoundingClientRect();
                    var win = element.ownerDocument.defaultView;

                    window.scrollTo({
                        top: rect.top + win.pageYOffset,
                        left: 0,
                        behavior: 'smooth'
                    });
                }

                return isValid;
            },
            orderAndPay() {
                if (this.validateForms()) {
                    let cartPositions = []
                    for (let position in this.getCart) {
                        let selectedServices = [];
                        for (let servicePosition in this.getCart[position].availableAdditionalServices) {
                            if (this.getCart[position].availableAdditionalServices[servicePosition].selected) {
                                selectedServices.push(this.getCart[position].availableAdditionalServices[servicePosition].id)
                            }
                        }
                        cartPositions.push({
                            id: this.getCart[position].id,
                            variation: this.getCart[position].variation,
                            quantity: this.getCart[position].quantity,
                            selectedAdditionalServices: selectedServices
                        })
                    }
                    var app = this
                    axios.post(Const.API_HOST + '/form/buy', {
                        method: app.paymentForm.method,
                        customer: {
                            name: app.checkoutForm.name,
                            surname: app.checkoutForm.surname,
                            phone: app.checkoutForm.phone,
                            email: app.checkoutForm.email,
                            address: app.checkoutForm.address,
                            city: app.checkoutForm.city,
                            postal: app.checkoutForm.postal,
                            fiscalNumber: app.checkoutForm.nip,
                            companyName: app.checkoutForm.coName,
                            statConsent: app.consentForm.statConsent,
                            owuConsent: app.consentForm.owuConsent,
                            adConsent: app.consentForm.adConsent
                        },
                        delivery: {
                            address: app.deliveryForm.address.name,
                            startDate: app.deliveryForm.startDate,
                            endDate: app.deliveryForm.endDate,
                            contactPhone: app.deliveryForm.contactPhone,
                            extraInfo: app.deliveryForm.deliveryInfo
                        },
                        cart: {
                            positions: cartPositions
                        }
                    })
                    .then(function (response) {
                        if (response.status === 200) {
                            app.$store.dispatch('clearCart')
                            window.location.href = response.data
                        }
                    }).catch(function (error) {
                        // eslint-disable-next-line no-console
                        console.log(error);
                    })
                }
            },
            sendRequest() {
                if (this.validateForms()) {
                    let cartPositions = []
                    for (let position in this.getCart) {
                        let selectedServices = [];
                        for (let servicePosition in this.getCart[position].availableAdditionalServices) {
                            if (this.getCart[position].availableAdditionalServices[servicePosition].selected) {
                                selectedServices.push(this.getCart[position].availableAdditionalServices[servicePosition].id)
                            }
                        }
                        cartPositions.push({
                            id: this.getCart[position].id,
                            variation: this.getCart[position].variation,
                            quantity: this.getCart[position].quantity,
                            selectedAdditionalServices: selectedServices
                        })
                    }
                    var app = this
                    axios.post(Const.API_HOST + '/form/order', {
                        customer: {
                            name: app.checkoutForm.name,
                            surname: app.checkoutForm.surname,
                            phone: app.checkoutForm.phone,
                            email: app.checkoutForm.email,
                            address: app.checkoutForm.address,
                            city: app.checkoutForm.city,
                            postal: app.checkoutForm.postal,
                            fiscalNumber: app.checkoutForm.nip,
                            companyName: app.checkoutForm.coName,
                            statConsent: app.consentForm.statConsent,
                            owuConsent: app.consentForm.owuConsent,
                            adConsent: app.consentForm.adConsent
                        },
                        delivery: {
                            address: app.deliveryForm.address.name,
                            startDate: app.deliveryForm.startDate,
                            endDate: app.deliveryForm.endDate,
                            contactPhone: app.deliveryForm.contactPhone,
                            extraInfo: app.deliveryForm.deliveryInfo
                        },
                        cart: {
                            positions: cartPositions
                        }
                    })
                        .then(function (response) {
                            if (response.status === 200) {
                                app.$store.dispatch('clearCart');
                                app.$router.push({ name: 'orderThanks' })
                            }
                        }).catch(function (error) {
                        // eslint-disable-next-line no-console
                        console.log(error);
                    })
                }
            }
        }
    }
</script>

<style scoped>
    @media (min-width: 1460px) {
        .container {
            max-width: 1400px;
        }
    }

    a {
        text-decoration: none;
    }

    .sticky-col {
        position: sticky;
        top: 120px;
        height: fit-content;
        overflow-y: auto;
    }
</style>